import aiseiAMd from '../content/aisei/a.md?raw'
import aiseiBMd from '../content/aisei/b.md?raw'
import cMd from '../content/c.md?raw'
import dMd from '../content/d.md?raw'
import escalationMd from '../content/escalation.md?raw'
import aiseiAppendixMd from '../content/aisei/appendix.md?raw'
import { GuideSection, GuideVariant, section } from '../core'
import { ContactNote } from '../components/ContactNote'

/**
 * アイセイ薬局（/guide/aisei）。機材が fi-800R キットと違うため A・B・付録だけ個別。
 *
 * - A: スキャナは Canon 製が主・一部 PFU（fi-800R ではない）で機種混在。
 *   機種固有の画面（「接続不能」ダイアログ・ソースの選択）は書けないので、
 *   機種に依らない確認（電源・USB・故障切り分け）だけを持つ。
 *   区分タイトルの「接続不能」も fi-800R の画面文言なので落とす。
 * - B: AutoScanHelper が無いため立ち上げ直しの手順（共有版 B-3）を落とし、B-1〜B-3 で
 *   振り直す。QuickSync・レセコン連携は運用開始時からウエルシア等と同じなので
 *   B-2・レセコン枝・図版 b1_* は共有版と同文。
 * - 付録2: 機材故障の持ち込み先はリコー窓口ではなく本部サポートデスク。
 * - C・D・それでも解決しないとき: 機材非依存なので共有。
 * - 連絡先: 本部サポートデスク。電話番号は紙にも web にも載せない (紙の ❷ と同じ語)。
 */
export const AISEI_SECTIONS: GuideSection[] = [
  section({
    id: 'a',
    label: 'A',
    title: 'スキャンできない',
    body: aiseiAMd,
  }),
  section({
    id: 'b',
    label: 'B',
    title: 'スキャンしたのに まもる君web・レセコンに出ない',
    body: aiseiBMd,
  }),
  section({
    id: 'c',
    label: 'C',
    title: 'まもる君web にログインできない',
    body: cMd,
  }),
  section({
    id: 'd',
    label: 'D',
    title: '読み取った内容がちがう',
    body: dMd,
  }),
  section({
    id: 'escalation',
    title: 'それでも解決しないとき',
    body: escalationMd,
  }),
  section({
    id: 'appendix',
    title: '付録',
    body: aiseiAppendixMd,
  }),
]

export const aiseiVariant: GuideVariant = {
  sections: AISEI_SECTIONS,
  contact: <ContactNote>本部サポートデスクへご連絡ください。</ContactNote>,
}
